@if (form && isFirst) {
  <div class="mb-2">
    <p class="py-2">When the Triggers are met, the <strong>Transaction Date Field</strong>
    will be populated with:
  </p>
  <div class="row mb-2">
    <div class="col-2">
      <select aria-label="Transaction Date Field will be populated with" type="number" class="form-select"
        data-cy="SelectEvent" [formControl]="form.controls.dateTypeId">
        <option [ngValue]="1">Date of Event</option>
        <option [ngValue]="2">Date Field Value</option>
      </select>
    </div>
    @if (form.controls?.dateTypeId?.value === 2) {
      <div class="col-2 text-end pe-2">
        <label class="mt-1"><strong>Date Field:</strong></label>
      </div>
      <div class="col-2"
        [class.has-error]="form.hasError('dateFieldRequired') && form.controls.characteristicId.touched">
        <select aria-label="Date Field" class="form-select" [formControl]="form.controls.characteristicId"
          data-cy="SelectDateField">
          <option [ngValue]="null">Select</option>
          @for (dateField of anchorTemplateDates; track dateField) {
            <option [ngValue]="dateField.characteristicID">{{
              dateField.label }}
            </option>
          }
        </select>
        @if (form.hasError('dateFieldRequired') && form.controls.characteristicId.touched) {
          <div
            class="help-block">Date Field
          is required.</div>
        }
      </div>
      <div class="col-6">
        <input type="checkbox" class="form-check-input me-2" [(ngModel)]="isCheckboxChecked"
          [ngModelOptions]="{standalone: true}" (change)="toggleCheckbox()">
        <label class="form-check-label">Choose default, if selected Field is blank?</label>
      </div>
    }
  </div>
  @if (form.controls?.dateTypeId?.value === 2 && isCheckboxChecked) {
    <div class="row mb-2"
      [class.has-error]="form.hasError('defaultDateFieldRequired') && form.controls.characteristicIdDefault1.touched">
      <div class="col-2 offset-2 text-end pe-2">
        <label for="defaultFieldSelect" class="mt-1"><strong>Default Date Field:</strong></label>
      </div>
      <div class="col-2">
        <select aria-label="Default Date Field" id="defaultFieldSelect" class="form-select"
          [formControl]="form.controls.characteristicIdDefault1" data-cy="DefaultDateField">
          <option [ngValue]="null">Select</option>
          @if (form.controls?.characteristicId?.value) {
            @for (dateField of anchorTemplateDefaultDates; track dateField) {
              <option [ngValue]="dateField.characteristicID">
                {{
                dateField.label }}
              </option>
            }
          }
          @if (!form.controls?.characteristicId?.value) {
            <option disabled>Select a Date Field Value first</option>
          }
        </select>
        @if (form.hasError('defaultDateFieldRequired') && form.controls.characteristicIdDefault1.touched) {
          <div
          class="help-block">Default Date Field is required.</div>
        }
      </div>
    </div>
  }
</div>
}

@if (form && !isFirst) {
  <div class="mb-2">
    <p class="py-2">The following Date Field will be populated:</p>
    @if (form.controls?.dateGroupTypeId?.value === 2) {
      <div class="row mb-2">
        <div class="col-2 text-end">
          <label class="pt-1"><strong>Date Field:</strong></label>
        </div>
        <div class="col-2">
          <select aria-label="Date Field" class="form-select" [formControl]="form.controls.characteristicId"
            data-cy="SelectDateField">
            @for (dateField of dateFieldDates; track dateField) {
              <option [ngValue]="dateField.characteristicId"
                [disabled]="dateField.disabled">{{ dateField.label }}
              </option>
            }
          </select>
        </div>
        <div class="col-2 text-end">
          <label class="pt-1"><strong>Populate with:</strong></label>
        </div>
        <div class="col-2">
          <select aria-label="Populate with" class="form-select" [formControl]="form.controls.populateTypeId"
            data-cy="PopulateTypeSelect">
            @for (tuple of populateTypes; track tuple) {
              <option [ngValue]="tuple[0]">{{tuple[1]}}</option>
            }
          </select>
        </div>
      </div>
    }
  </div>
}

<div class="d-flex mb-2">
  <div class="ms-auto">
    @if (form.controls?.dateTypeId?.value === 2) {
      <span class="me-3">
        <em>Note: If all selected date values are blank, Transaction Date will be defaulted to Date of Event.</em>
      </span>
    }
    <button class="btn btn-light btn-sm me-2" (click)="cancel()" data-cy="CancelAddDate">
      Cancel
    </button>
    <button class="btn btn-info btn-sm" (click)="save()" [disabled]="!form?.valid" data-cy="SaveAddDate">
      Save
    </button>
  </div>
</div>